var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-block"},[_c('ButtonDefault',{attrs:{"buttonName":_vm.$t('shootings.showMore'),"loading":_vm.loading},on:{"click":_vm.loadMore}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }